import { env } from '../../constants';
import { FeatureFlagsRequestData, ServiceResponse } from './types';

export const postFeatureFlags = async (
  data: FeatureFlagsRequestData
): Promise<ServiceResponse | undefined> => {
  try {
    const response = await fetch(`${env.VITE_UNLEASH_PROXY_URL}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch feature flags. Status: ${response.status} ${response.statusText}`
      );
    }

    return response.json() as Promise<ServiceResponse>;
  } catch (error) {
    console.error('Error during postFeatureFlags call:', {
      errorMessage: error instanceof Error ? error.message : String(error),
      sendingData: data,
      isAppInBackground: document.visibilityState === 'hidden',
      isUserOnline: navigator.onLine
    });
  }
};
